module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 024.829cdcce.jpg";